export var ApprovalStepType;
(function (ApprovalStepType) {
    ApprovalStepType["AGREEMENT"] = "AGREEMENT";
    ApprovalStepType["DRAFT"] = "DRAFT";
    ApprovalStepType["APPROVAL"] = "APPROVAL";
})(ApprovalStepType || (ApprovalStepType = {}));
export var ApprovalStepStatus;
(function (ApprovalStepStatus) {
    ApprovalStepStatus["PENDING"] = "PENDING";
    ApprovalStepStatus["APPROVED"] = "APPROVED";
    ApprovalStepStatus["REJECTED"] = "REJECTED";
    ApprovalStepStatus["SKIPPED"] = "SKIPPED";
})(ApprovalStepStatus || (ApprovalStepStatus = {}));
export var DocumentApprovalStatus;
(function (DocumentApprovalStatus) {
    DocumentApprovalStatus["DRAFT"] = "DRAFT";
    DocumentApprovalStatus["IN_PROGRESS"] = "IN_PROGRESS";
    DocumentApprovalStatus["APPROVED"] = "APPROVED";
    DocumentApprovalStatus["REJECTED"] = "REJECTED";
})(DocumentApprovalStatus || (DocumentApprovalStatus = {}));
export const APPROVAL_STEP_TYPE_LABEL = {
    [ApprovalStepType.AGREEMENT]: "합의",
    [ApprovalStepType.DRAFT]: "기안",
    [ApprovalStepType.APPROVAL]: "결재",
};
export const APPROVAL_STEP_STATUS_LABEL = {
    [ApprovalStepStatus.PENDING]: "대기",
    [ApprovalStepStatus.APPROVED]: "승인",
    [ApprovalStepStatus.REJECTED]: "반려",
    [ApprovalStepStatus.SKIPPED]: "생략",
};
export const DOCUMENT_APPROVAL_STATUS_LABEL = {
    [DocumentApprovalStatus.DRAFT]: "임시저장",
    [DocumentApprovalStatus.IN_PROGRESS]: "진행중",
    [DocumentApprovalStatus.APPROVED]: "승인완료",
    [DocumentApprovalStatus.REJECTED]: "반려",
};
/**
 * IN_PROGRESS 상태를 현재 결재 단계에 따라 동적 라벨로 표시
 * - AGREEMENT → "합의 대기"
 * - DRAFT → "확인 대기"
 * - APPROVAL → "승인 대기"
 * - 그 외 → "결재중"
 */
export function getApprovalDisplayLabel(approvalStatus, currentStepType) {
    if (approvalStatus !== DocumentApprovalStatus.IN_PROGRESS) {
        return (DOCUMENT_APPROVAL_STATUS_LABEL[approvalStatus] ?? approvalStatus);
    }
    switch (currentStepType) {
        case ApprovalStepType.AGREEMENT:
            return "합의 대기";
        case ApprovalStepType.DRAFT:
            return "확인 대기";
        case ApprovalStepType.APPROVAL:
            return "승인 대기";
        default:
            return "결재중";
    }
}
